import {processProjectService} from './../project-services/actions'
import * as mutations from '../../mutation-types'

export const fetchApplicationsByIds = (store, params = {}) => {
    return axios.get('/api/applications/listById', { params })
        .then(res => {
            return res
        })
}

export const processProject = (store, item) => {
    let applications = [
        'occupancy_certificates',
        'after_hours_permits',
        'determinations',
        'misc_services',
        'dot_permits',
        'inspections',
        'violations',
        'trackings',
        'filings',
        'permits'
    ]

    _.each(applications, application => {
        if (item[application]) {
            const moduleName = _.snakeCase(application).replace(/_/g, '-')

            _.each(item[application], entry => store.dispatch(`${moduleName}/processItem`, entry))
        }
    })

    if (item.project_services) {
        _.each(item.project_services, item => processProjectService(store, item))
        delete item.project_services
    }

    if (item.files) {
        _.each(item.files, file => store.dispatch('processFile', file))
        delete(item.files)
    }

    if (item.tasks) {
        _.each(item.tasks, task => store.dispatch('processTask', task))
        delete(item.tasks)
    }

    if (item.latest_task) {
        store.dispatch('processTask', item.latest_task)
        item.latest_task = item.latest_task.id
    }

    if (item.notes) {
        _.each(item.notes, note => store.dispatch('processNote', note))
        if(item.proposal && item.proposal.notes)    {
            _.each(item.proposal.notes, note => store.dispatch('processNote', note))
        }
        delete(item.notes)
    }

    if (item.subscribers) {
        _.each(item.subscribers, subscriber => store.dispatch('processSubscriber', subscriber))
        delete(item.subscribers)
    }

    if (item.subscribed_contacts) {
        _.each(item.subscribed_contacts, subscribedContact => store.dispatch('processSubscribedContact', subscribedContact))
        delete(item.subscribed_contacts)
    }

    if (item.contacts) {
        _.each(item.contacts, contact => store.dispatch('processContact', contact))
        _.each(item.contacts, contact => store.dispatch('processProjectContact', {
            project_id: item.id, contact_id: contact.id, role: contact.pivot.role
        }))
    }

    if (item.company) {
        store.dispatch('processCompany', item.company)
        item.company_name = item.company.name
        delete item.company
    }

    if (item.contact) {
        store.dispatch('processContact', item.contact)
        item.contact_name = item.contact.full_name
        delete item.contact
    }

    if (item.primary_contact) {
        store.dispatch('processContact', item.primary_contact)
        delete item.primary_contact
    }

    if (item.secondary_contact) {
        store.dispatch('processContact', item.secondary_contact)
        delete item.secondary_contact
    }

    if (item.latest_note) {
        store.dispatch('processNote', item.latest_note)
        delete(item.latest_note)
    }

    if (item.project_services) {
        _.each(item.project_services, ps => store.dispatch('processProjectService', ps))
        delete(item.project_services)
    }

    store.commit(mutations.ADD_OR_UPDATE_PROJECT, item)
}

export const fetchTotalHoursPriceByProjectId = (store, id) => {
    return axios.get(`/api/projects/${id}/total-hours-price`)
}

export const fetchProjects = (store, params) => {
    return axios.get(`/api/projects`, { params })
        .then(res => {
            _.each(res.data.data, item => item && processProject(store, item))
            store.commit(mutations.SET_PROJECTS_TOTAL, res.data.total)
            return res
        })
}

export const fetchProjectById = (store, id) => {
    return axios.get(`/api/projects/${id}`)
        .then(response => {
            processProject(store, response.data.data)
            return response
        })
}

export const createProject = (store, item) => {
    return axios.post(`/api/projects`, item)
        .then(res => {
            processProject(store, res.data.data)
            return res
        })
}

export const updateProject = (store, item) => {
    return axios.patch(`/api/projects/${item.id}`, item)
        .then(res => {
            processProject(store, res.data.data)
            return res
        })
}

export const partialUpdateProject = (store, item) => {
    return axios.patch(`/api/projects/${item.id}/partial`, item)
        .then(res => {
            processProject(store, res.data.data)
            return res
        })
}

export const createOrUpdateProject = (store, item) => {
    return item.id ?
        updateProject(store, item) :
        createProject(store, item)
}

export const removeProject = (store, item) => {
    return axios.delete(`/api/projects/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_PROJECT, item)
            store.commit(mutations.REMOVE_FOLLOWED_PROJECT, item)
            return res
        })
}

export const setCurrentProjectId = (store, id) => {
    store.commit(mutations.SET_CURRENT_PROJECT_ID, id)
}

export const sendProjectEmail = (store, emailData) => {
    return axios.post(`/api/projects/${emailData.entityIdProperty}/email`, emailData)
}